export default __webpack_public_path__ + "static/media/logo2.268e9a69.jpeg";